import { hideElement, showElement } from './../../utils/dom'
import Cart from './cart'

import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class CartRelatedProductsBlock extends BaseComponent {
  cart: Nullable<Cart>
  relatedProducts: Nullable<HTMLElement>
  isAutoRecommendations: boolean

  constructor() {
    super()

    this.relatedProducts = this.querySelector('[data-cart-related-products]')
    this.cart = this.closest('cart-page')
    this.isAutoRecommendations = this.hasAttribute('is-auto-recommendations')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('update-nodes', this.handleCartFinishUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('update-nodes', this.handleCartFinishUpdate)
    }
  }

  handleCartFinishUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    if (!this.relatedProducts) {
      return
    }

    const blockId = this.getAttribute('block-id')
    const newRelatedProducts = node.querySelector(
      `cart-related-products-block[block-id="${blockId}"] [data-cart-related-products]`,
    )

    if (!newRelatedProducts) {
      return
    }

    if (this.isAutoRecommendations) {
      const newUrl = newRelatedProducts.getAttribute('data-url')

      this.relatedProducts.setAttribute('data-url', newUrl)

      if (newUrl) {
        this.relatedProducts.loadProducts()
        showElement(this)
      } else {
        this.relatedProducts.erase()
        hideElement(this)
      }
    } else {
      const clonedNewRelatedProducts = newRelatedProducts.cloneNode(true)

      this.relatedProducts.replaceChildren(
        ...clonedNewRelatedProducts.childNodes,
      )
    }
  }
}

export default CartRelatedProductsBlock
